import { IGetAllUserAction, IGetAllUserParams } from './allUsers.interface';
import { GetAllUserTypes } from './allUsers.type';

export const getAllUser = (payload: IGetAllUserParams): IGetAllUserAction => ({
	type: GetAllUserTypes.GET_ALL_USER,
	payload,
});
